import { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  PremiumInfoDocument,
  PremiumInfoQuery,
  UpdatePremiumInfoInput,
  useUpdatePremiumInfoMutation,
} from '../../../../schema';
import { toast } from 'react-toastify';
import { FORM_ERROR, SubmissionErrors } from 'final-form';

type Props = {
  data: PremiumInfoQuery | undefined;
};

export type EditPremiumAccessFormValues = {
  title: string;
  description: string;
  backgroundImageId?: string;
  mechanicsText: string;
  buttonText: string;
  buttonActionCode: string;
};

export const useEditPremiumAccessForm = ({ data }: Props) => {
  const history = useHistory();

  const [
    updatePremiumInfo,
    { data: mutationData, loading, error },
  ] = useUpdatePremiumInfoMutation();

  const premiumInfo = data?.premiumInfo;

  const initialValues: EditPremiumAccessFormValues = {
    title: premiumInfo?.title ?? '',
    description: premiumInfo?.description ?? '',
    backgroundImageId: premiumInfo?.backgroundImage?.id ?? '',
    mechanicsText: premiumInfo?.mechanicsText ?? '',
    buttonText: premiumInfo?.buttonText ?? '',
    buttonActionCode: premiumInfo?.buttonActionCode ?? '',
  };

  const onCancel = useCallback(() => {
    history.push('/battle-pass/premium-access');
  }, [history]);

  const onSubmit = useCallback(
    async (values: EditPremiumAccessFormValues) => {
      const input: UpdatePremiumInfoInput = {
        title: values.title,
        description: values.description,
        backgroundImageId: values.backgroundImageId || null,
        mechanicsText: values.mechanicsText,
        buttonText: values.buttonText,
        buttonActionCode: values.buttonActionCode,
      };

      try {
        await updatePremiumInfo({
          variables: { input },
          refetchQueries: [{ query: PremiumInfoDocument }],
        });
      } catch {
        toast.error('Ошибка сохранения информации о Premium-доступе');
        return { [FORM_ERROR]: 'Ошибка сохранения' } as SubmissionErrors;
      }
    },
    [updatePremiumInfo]
  );

  useEffect(() => {
    if (mutationData !== undefined) {
      toast.success('Информация о Premium-доступе успешно сохранена');
      onCancel();
    }
  }, [mutationData, onCancel]);

  useEffect(() => {
    if (error) {
      toast.error('Ошибка сохранения информации о Premium-доступе');
    }
  }, [error]);

  return { initialValues, onSubmit, onCancel, loading };
};
